import { render } from "./CampaignBannerSlider.vue?vue&type=template&id=33e51f8d&scoped=true"
import script from "./CampaignBannerSlider.vue?vue&type=script&lang=js"
export * from "./CampaignBannerSlider.vue?vue&type=script&lang=js"

import "./CampaignBannerSlider.vue?vue&type=style&index=0&id=33e51f8d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e51f8d"]])

export default __exports__